import type { KitchenSceneBuilder } from '../kitchen-scene-builder.class';

/**
 * Calculate kitchen bounds
 */
export const calculateKitchenBoundsCfn = (
	_self: KitchenSceneBuilder,
	{ kitchenSize }: { kitchenSize: { width?: number; depth?: number; height?: number } }
): { min: { x: number; y: number; z: number }; max: { x: number; y: number; z: number } } => {
	const width = kitchenSize.width ?? 96;
	const depth = kitchenSize.depth ?? 36;
	const height = kitchenSize.height ?? 50;

	return {
		min: { x: -width / 2, y: 0, z: -depth / 2 },
		max: { x: width / 2, y: height, z: depth / 2 }
	};
};

/**
 * Calculate camera configuration
 */
export const calculateCameraConfigCfn = (
	_self: KitchenSceneBuilder,
	{ kitchenSize, zoom = 1.0 }: {
		kitchenSize: { width?: number; depth?: number; height?: number };
		zoom?: number;
	}
): { position: { x: number; y: number; z: number }; target: { x: number; y: number; z: number } } => {
	const width = kitchenSize.width ?? 96;
	const depth = kitchenSize.depth ?? 36;
	const height = kitchenSize.height ?? 50;

	// Calculate optimal distance based on kitchen size
	const maxDim = Math.max(width, depth);
	const distance = (maxDim * 1.5) / zoom;

	return {
		position: {
			x: 0,
			y: height * 0.8,
			z: distance
		},
		target: {
			x: 0,
			y: height * 0.4,
			z: 0
		}
	};
};
